/**
 * PrimeNG table fields required to uncheck rows selected with dataKey.
 * Structural on purpose so tests do not boot Table.
 */
export interface SurfaceSelectionTable<T> {
    selection: T[] | null;
    selectionKeys: Record<string, unknown>;
    tableService?: { onSelectionChange(): void };
}

/**
 * Result shape shared by batched bon de travail calls (`ReponseBase` / `ResultatBase`).
 */
export interface ResultatActionGroupee {
    estUnSucces?: boolean;
    valeur?: unknown;
}

/**
 * True when every call in the batch succeeded and returned a payload.
 * An empty batch, a partial failure, or a success without `valeur` is not a success.
 */
export function actionGroupeeReussie(results: ResultatActionGroupee[] | null | undefined): boolean {
    return !!results?.length && results.every(r => !!r?.estUnSucces && r.valeur != null);
}

/**
 * Unchecks every row of a PrimeNG table that uses dataKey.
 * Assigning [] on the component model leaves `selectionKeys` populated, and
 * OnPush `p-tableCheckbox` stays highlighted because `isSelected` treats [] as present.
 */
export function decocherSelectionTable<T>(table: SurfaceSelectionTable<T> | null | undefined): T[] {
    const vide: T[] = [];
    if (!table) {
        return vide;
    }
    table.selection = vide;
    table.selectionKeys = {};
    table.tableService?.onSelectionChange();
    return vide;
}

/**
 * Mirrors PrimeNG 17 `Table.isSelected` when `dataKey` is set.
 * Used to prove that clearing keys is what unchecks the row.
 */
export function ligneSelectionneeParCle<T extends Record<string, unknown>>(
    table: SurfaceSelectionTable<T> | null | undefined,
    ligne: T | null | undefined,
    dataKey: string
): boolean {
    if (!ligne || !table?.selection) {
        return false;
    }
    const cle = ligne[dataKey];
    return table.selectionKeys[String(cle)] !== undefined;
}
